import UntitledIcon from '@payaca/untitled-icons';
import type { FC, PropsWithChildren } from 'react';

type TProps = PropsWithChildren<{
  /** Shown as a corner badge when more than one node is being moved. */
  count?: number;
}>;

/**
 * A compact chip for the {@link SortableTree} drag overlay: a grip plus a
 * short summary of the dragged node, supplied as children.
 */
const SortableTreeDragPreview: FC<TProps> = (props) => {
  const { count, children } = props;

  return (
    <div className="relative inline-flex max-w-full cursor-move items-center gap-2 rounded-lg bg-white px-2.5 py-1.5 shadow-lg ring-1 ring-gray-200">
      <UntitledIcon name="draggable" className="size-5 shrink-0" aria-hidden />
      <div className="flex min-w-0 items-center gap-2 truncate">{children}</div>
      {count != null && count > 1 && (
        <span className="absolute -top-2.5 -right-2.5 flex size-6 items-center justify-center rounded-full bg-blue-500 text-xs font-semibold text-white">
          {count}
        </span>
      )}
    </div>
  );
};

export default SortableTreeDragPreview;
